import { AxiosResponse, AxiosError } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TPaymentMakeListGetReq,
  TPaymentMakeListGetRes,
  TPaymentSiharaiSimePostReq,
  TPaymentPrintSiharaiMeisaisyoReq,
  TPaymentSiharaiSimeCheckListGetRes,
  TPaymentSiharaiMeisaisyoCheckListGetRes,
} from "./TPayment"

/**
 * 支払合計一覧画面に対するAPIリクエスト用サービス
 *
 * @export
 * @class MenuService
 * @extends {ConnectApi}
 */
export default class MakePaymentService extends ConnectApi {
  /**
   * 支払合計一覧取得
   *
   * @param {TPaymentMakeListGetReq} params
   * @param {(param: TApiResponse<TPaymentMakeListGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TPaymentMakeListGetRes[]>) => any} reject
   * @memberof makePaymentService
   */
  getList = async (
    params: TPaymentMakeListGetReq,
    resolve?: (param: TApiResponse<TPaymentMakeListGetRes[]>) => any,
    reject?: (param: TApiResponse<TPaymentMakeListGetRes[]> | undefined) => any
  ) => {
    try {
      //API呼出
      const res: AxiosResponse<TApiResponse<TPaymentMakeListGetRes[]>> =
        await this.getInner(`/billing/siharaigoukei`, params)
      return res.data
    } catch (err) {
      if (typeof err !== "object" || err == null) throw err
      const error = err as TApiResponse<TPaymentMakeListGetRes[]>
      throw reject ? reject(error) : error
    }
  }

  /**
   * 支払締め処理実行前チェック
   *
   * @param {TPaymentSiharaiSimePostReq} params
   * @param {(param: TApiResponse<TPaymentSiharaiSimeCheckListGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TPaymentSiharaiSimeCheckListGetRes[]>) => any} reject
   * @memberof makePaymentService
   */
  getCheckList = async (
    params: TPaymentSiharaiSimePostReq,
    resolve?: (
      param: TApiResponse<TPaymentSiharaiSimeCheckListGetRes[]>
    ) => any,
    reject?: (
      param: TApiResponse<TPaymentSiharaiSimeCheckListGetRes[]> | undefined
    ) => any
  ) => {
    try {
      //API呼出
      const res: AxiosResponse<
        TApiResponse<TPaymentSiharaiSimeCheckListGetRes[]>
      > = await this.getInner(`/billing/siharaisimechecklist`, params)
      return res.data
    } catch (err) {
      if (typeof err !== "object" || err == null) throw err
      const error = err as TApiResponse<TPaymentSiharaiSimeCheckListGetRes[]>
      throw reject ? reject(error) : error
    }
  }

  /**
   * 支払明細書出力処理実行前チェック
   *
   * @param {TPaymentSiharaiSimePostReq} params
   * @param {(param: TApiResponse<TPaymentSiharaiMeisaisyoCheckListGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TPaymentSiharaiMeisaisyoCheckListGetRes[]>) => any} reject
   * @memberof makePaymentService
   */
  getSiharaiMeisaisyoCheckList = async (
    params: TPaymentSiharaiSimePostReq,
    resolve?: (
      param: TApiResponse<TPaymentSiharaiMeisaisyoCheckListGetRes[]>
    ) => any,
    reject?: (
      param: TApiResponse<TPaymentSiharaiMeisaisyoCheckListGetRes[]> | undefined
    ) => any
  ) => {
    try {
      //API呼出
      const res: AxiosResponse<
        TApiResponse<TPaymentSiharaiMeisaisyoCheckListGetRes[]>
      > = await this.getInner(`/billing/siharaimeisaisyochecklist`, params)
      return res.data
    } catch (err) {
      if (typeof err !== "object" || err == null) throw err
      const error = err as TApiResponse<
        TPaymentSiharaiMeisaisyoCheckListGetRes[]
      >
      throw reject ? reject(error) : error
    }
  }

  /**
   * 支払締め処理
   *
   * @param {TPaymentSiharaiSimePostReq} params
   * @param {(param: TApiResponse<TPaymentSiharaiSimePostRes[]>) => any} resolve
   * @param {(param: TApiResponse<TPaymentSiharaiSimePostRes[]>) => any} reject
   * @memberof makePaymentService
   */
  siharaiSime = async (params: TPaymentSiharaiSimePostReq) => {
    try {
      //API呼出
      await this.postInner(`/billing/siharaisime`, params)
    } catch (err) {
      throw err
    }
  }

  /**
   * 支払明細書印刷
   *
   * @param {TPaymentPrintSiharaiMeisaisyoReq} params
   * @memberof makePaymentService
   */
  printSiharaiMeisaisyo = async (
    params: TPaymentPrintSiharaiMeisaisyoReq,
    resolve?: (param: TApiResponse<Blob>) => any,
    reject?: (param: AxiosError<TApiResponse<Blob>>) => any
  ) => {
    try {
      //API呼出
      const res: AxiosResponse<Blob> = await this.postInner(
        `/report/CreateReport/G060602`,
        params
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
